/**
 * Component to Show ScrFile Links details
 *
 *
 * @author Sneha
 */

import React, { useEffect, useState, useContext } from 'react';

import { SCRFilesLink, Doctors } from '../../../../models';

import { message, Typography, Skeleton, Modal, Form, Empty, Spin, Popconfirm, Tabs } from 'antd';

import { DeleteOutlined } from '@ant-design/icons';

import { Location, GlobalContext, useTranslation, Button, Card } from 'soxo-bootstrap-core';

import FileLoader from './../../../../components/file-loader/file-loader';

import DoctorNotesLabResult from '../../../screening/lab-result/lab-result-doctor-notes';

// Import Other Components
import { ReportPreviewFileLoader } from './../../../../components/report-preview/report-preview';
import VisitInfo from '../../../emr/components/visit-info/visit-info';
import { Questionaire } from '../../../screening/questionaire/questionaire';
import { ClinicalInfoView } from './clinical-info-view';
import DocumentUploadComponent from '../../../emr/components/document-upload/document-upload';
// Import Other Components Ends

import './report-links-viewer.scss';

const { TabPane } = Tabs;
const formItemLayout = {
    layout: 'vertical',
};

/**
 *
 * @returns
 */
export default function ReportLinksView({
    reportConfig = {
        baseUrl: 'http://localhost:3800/',
    },
    documentConfig = {
        baseUrl: 'http://localhost:3800/',
    },

    enableGeneticConsultation,
    enableGenerateReport,
    // used to enable question aire.by default it is disabled
    enableQuestionnaire,
    ...props
}) {
    var params = Location.search();

    const id = params.opb_id;

    let consultation = params.consultation;

    let { enableConsultation } = props;

    //Get logged user data
    const { user, isMobile } = useContext(GlobalContext);

    const [selected, setSelected] = useState({
        reports: [],
        report_links: [],
    });

    const [isDoctor, setDoctor] = useState(false);

    const [loadingIndex, setLoadingIndex] = useState(null); // Track the index of the report being loaded

    const [loading, setLoading] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);

    //Variable for upload Modal
    const [uploadVisible, setUploadVisible] = useState(false);

    //Variable for upload Modal
    const [reportVisible, setReportVisible] = useState(false);

    const [fileName, setFileName] = useState([]);

    // variable for final report details
    const [finalReport, setFinalReport] = useState({});

    const [referenceId, setReferenceId] = useState(params.opb_id);

    const { t } = useTranslation(); // To Translate to another language

    const [patient, setPatient] = useState({
        scrReportmas: [],

        opReg: {},
    }); //Patiants list array

    useEffect(() => {
        getReports(params.opb_id);
        getfileLinks();
        // Get final report file name
        // getFinalReport();
        //Check the logged use is doctor or not
        if (user.staff_id) {
            getDoctorDeatils(user.staff_id);
        }
    }, []);

    /**
     * Fetches scrfile  details from a specified API endpoint using item pointer and accession number parameters.
     * Updates the component's state or performs actions based on the retrieved file information.
     */

    function getfileLinks() {
        SCRFilesLink.getScrfileLinksMasterData(params.mode).then((result) => {
            setFileName({
                filepath: result.result[0].filepath,
                // sflink_filename: result.data.result[0].sflink_filename
            });
        });
    }

    /**
     * Getting reports
     *
     */

    function getReports(billId) {
        //Load report with accession no
        SCRFilesLink.getReports(billId).then((result) => {
            if (result && result?.data) {
                setPatient(result.data);
                setFinalReport(result.data.report);
                if (result.data.scrReportmas[0]) {
                    const availableReport = result.data.scrReportmas.filter((ele) => ele.report_available === true);
                    // The first report is selected here

                    if (availableReport.length) {
                        setSelected(availableReport[0]);
                    }
                }
            }

        });
    }

    // Get doctor details to check logged user is doctor or not
    function getDoctorDeatils(id) {
        Doctors.getDoctorDeatils(id).then((result) => {
            if (result) {
                setDoctor(true);
            }
        });
    }

    /**
     *
     * Start the consultation
     */
    function onStartConsultation() {
        // The window.vuplex object gets created when the page starts loading,
        // so we double-check that it exists before using it here.
        // You can skip this step if you're sending a message after the page has loaded.

        let message = {
            url: window.location.href + '&consultation=true',
            op_no: id,
            branch_name: user.firm.f_desc,
            isDoctor: isDoctor,
            room: patient.bill_id + '-' + user.firm.f_code + '-room',
            display_name: patient.op_reg.op_fname + ' ' + patient.op_reg.op_lname + '-' + patient.bill_no + '-' + user.firm.f_desc,
        };

        // console.log(message);

        if (window.vuplex) {
            // The window.vuplex object already exists, so go ahead and send the message.
            sendMessageToCSharp(message);
        } else {
            // The window.vuplex object hasn't been initialized yet because the page is still
            // loading, so add an event listener to send the message once it's initialized.

            window.addEventListener('vuplexready', sendMessageToCSharp);
        }
    }

    /**
     * Send Message to VR .
     */
    function sendMessageToCSharp(message) {
        // This object passed to postMessage() automatically gets serialized as JSON
        // and is emitted via the C# MessageEmitted event. This API mimics the window.postMessage API.

        if (window.vuplex) {
            window.vuplex.postMessage(message);
        }
    }

    /**
     * delete uploaded file
     *
     */
    async function deleteFile(ele) {
        message.loading('Deleting digital report');

        await SCRFilesLink.deleteReport(ele.sflink_id);

        setSelected({
            reports: [],
        });
        // message.success('Report is Deleted');
        getReports(params.opb_id);
    }

    /**
     *
     */
    function reportPreview(selected,reportConfig) {
        //let location = `${process.env.REACT_APP_REPORT_PATH}/${selected.sflink_type}/` + selected.sflink_filename;
        // file location
        let location = selected.sflink_filename;
        switch (selected.sflink_type) {
            case 'RAW':
                // return <LoadPDFImg report={selected} />;

                // return (
                //     <a target="_blank" rel="noreferrer" href={selected.report_filename} className={`report-link vehicle-card card`}>
                //         <h1>PACS</h1>
                //         View PACS Image
                //     </a>
                // );
                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {props.enableDelete ? (
                            <Popconfirm
                                title="Are you sure you want to delete the report ? "
                                onConfirm={() => deleteFile(selected)}
                                onCancel={() => { }}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button type="secondary" size={'small'} style={{ width: '15%', alignSelf: 'end', marginBottom: '15px' }}>
                                    <DeleteOutlined /> Delete
                                </Button>
                            </Popconfirm>
                        ) : null}
                        <FileLoader config={reportConfig} url={location} type={selected.sflink_type} {...props} />
                    </div>
                );

                break;
            case 'VCF':
                    // return <LoadPDFImg report={selected} />;
    
                    // return (
                    //     <a target="_blank" rel="noreferrer" href={selected.report_filename} className={`report-link vehicle-card card`}>
                    //         <h1>PACS</h1>
                    //         View PACS Image
                    //     </a>
                    // );
                    return (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {props.enableDelete ? (
                                <Popconfirm
                                    title="Are you sure you want to delete the report ? "
                                    onConfirm={() => deleteFile(selected)}
                                    onCancel={() => { }}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button type="secondary" size={'small'} style={{ width: '15%', alignSelf: 'end', marginBottom: '15px' }}>
                                        <DeleteOutlined /> Delete
                                    </Button>
                                </Popconfirm>
                            ) : null}
                            <FileLoader config={reportConfig} url={location} type={selected.sflink_type} {...props} />
                        </div>
                    );
    
                break;
            case 'JSON':
                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {props.enableDelete ? (
                            <Popconfirm
                                title="Are you sure you want to delete the report ? "
                                onConfirm={() => deleteFile(selected)}
                                onCancel={() => { }}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button type="secondary" size={'small'} style={{ width: '15%', alignSelf: 'end', marginBottom: '15px' }}>
                                    <DeleteOutlined /> Delete
                                </Button>
                            </Popconfirm>
                        ) : null}
                        <FileLoader config={reportConfig} url={location} type={selected.sflink_type} {...props} />
                    </div>
                );
                break;
            case 'RPT':
                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {props.enableDelete ? (
                            <Popconfirm
                                title="Are you sure you want to delete the report ? "
                                onConfirm={() => deleteFile(selected)}
                                onCancel={() => { }}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Button type="secondary" size={'small'} style={{ width: '15%', alignSelf: 'end', marginBottom: '15px' }}>
                                    <DeleteOutlined /> Delete
                                </Button>
                            </Popconfirm>
                        ) : null}
                        <FileLoader config={reportConfig} {...props} url={location} type={selected.sflink_type} />
                    </div>
                );

                break;

            case 'IMG':
                //  return <LoadPDFImg report={selected} />;
                return (
                    <a target="_blank" rel="noreferrer" href={selected.sflink_filename} className={`report-link vehicle-card card`}>
                        <h1>PACS</h1>
                        View PACS Image
                    </a>
                );
                break;
        }
    }

    /**
     * Handle Publish Report to open medicant.
     */

    const ReprtPublishfinalReport = () => {
        // Extract the 'publish_report' object from props and store it in 'values'
        let values = props.publish_report;
        // Construct the 'parameter' string by concatenating various values from 'values', 'user.name'
        let parameter =
            values.mode + ',' + values.submode + ',' + values.passcode + ',' + values.passvalue + ',' + user.name + '~' + patient.opReg.opb_opno;
        // Make the POST request to the server
        fetch('http://localhost:3800/report/report-publish', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                parameter,
            }),
        })
            .then((response) => {
                // Check if the response status is 200 (success)
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json(); // Parse the JSON data from the response
            })

            .catch((error) => {
                //Handle any errors that occur during the request
                console.error('Error:', error);
            });
    };

    /**
     * Asynchronous function to publish the final report.
     * This function awaits the result of publishing the report using SCRFilesLink.publishReport().
     */
    async function ReportPublish() {
        // The function expects `params.opb_id` to be defined externally.
        // let formBody = {
        //     item_ptr: params.item_ptr,
        // };

        if (finalReport.report_filename) {
            setBtnLoading(true);

            const result = await SCRFilesLink.publishReport(params.opb_id);
            // Check if the result is truthy and contains a 'success' property.
            setBtnLoading(false);

            if (result && result.success) {
                // If successful, display a success message.

                message.success(result.message);
            } else {
                // If unsuccessful, display an error message.

                message.error(result.message);
            }
        } else {
            message.warning('Final Report not available');
        }
    }

    //Upload Modal
    function uploadModal() {
        setUploadVisible(true);
    }

    /**
     * Select the final report
     *
     * @param {*} report
     */
    const selectFinalReport = () => {
        // Set loading state for the final report
        setLoadingIndex('finalReport');

        // Simulate the final report selection or API call
        setTimeout(() => {
            // Set the selected report
            setSelected({
                final_report: true,
                sflink_filename: finalReport.report_filename,
            });

            // For Mobile view, open the modal
            if (isMobile) {
                setReportVisible(true);
            }

            // Reset loading state
            setLoadingIndex(null);
        }, 1000); // Replace with actual API call logic if needed
    };

    const selectReportWithLoading = (report, index) => {
        // Set the index of the report being loaded
        setLoadingIndex(index);

        // Simulate an async operation or handle actual logic
        setTimeout(() => {
            if (report && report.opbilld && report.opbilld[0]?.opbd_itemptr) {
                setSelected(report);
            }
            setLoadingIndex(null); // Reset loading state after operation
        }, 1000); // Replace with actual async call or remove timeout if unnecessary
    };

    return (
        <>
            {loading ? (
                <Skeleton />
            ) : (
                <>
                    <Card className="report-links-viewer">
                        <div className="page-header">
                            {/* {opbilld && opbilld[0] && ['NMGS', 'NWGS'].indexOf(opbilld[0]) !== -1 ? */}

                            {/* : null} */}

                            <div className="page"></div>

                            {/* Actions Starts */}
                            <div className="actions">
                                {/* Start Consultation */}
                                {enableConsultation ? (
                                    <>{consultation != 'true' ? <Button onClick={onStartConsultation}>{t('Start Consultation')}</Button> : null}</>
                                ) : null}
                                {/* Start Consultation Ends */}

                                {/* Document Upload */}
                                <DocumentUploadComponent
                                    referenceId={params.opb_id}
                                    referenceNumber={params.opno}
                                    reportConfig={documentConfig}
                                    props={props}
                                    guest={{
                                        bill_id: params.opb_id,
                                        op_no: params.opno,
                                    }}
                                />
                                {/* Document Upload Ends */}

                                <ClinicalInfoView visit_id={params.opb_id} />

                                <Questionaire reference_id={params.opb_id} mode={'bill'} />

                                {params.opb_id ? (
                                    <>
                                        <LabResultsButton referenceId={params.opb_id} />
                                    </>
                                ) : null}

                                <Button size="small" type="primary" onClick={ReportPublish} loading={btnLoading} disabled={btnLoading}>
                                    {t('Publish Report')}
                                </Button>

                                {enableGenerateReport ? (
                                    <Button size="small" type="primary" onClick={ReprtPublishfinalReport}>
                                        {t('Create Final Report')}
                                    </Button>
                                ) : null}

                                {enableGeneticConsultation ? (
                                    <Button size="small" onClick={uploadModal}>
                                        {t('Genetic Upload')}
                                    </Button>
                                ) : null}
                            </div>
                            {/* Actions Ends */}
                        </div>

                        {params.opb_id ? (
                            /* Patient Visit Information */
                            <VisitInfo
                                mode={'opreg'}
                                reference_number={params.opno}
                                enableBillnumber={props.enableBillnumber}
                                onReceiveGuestDetails={(patient) => { }}
                                callback={async (values, bills) => {
                                    setReferenceId(values);
                                    // If the patient is changed using change pateint button, the url is changed according to the newly selcted customer
                                    // For that opb_id, opb_bno and opb_opno are taken from the list of bills

                                    let record = bills.filter((ele) => ele.opb_id === values)[0];

                                    let redirectLink;

                                    if (props.path) {
                                        redirectLink = props.path;
                                    }

                                    redirectLink = redirectLink.replace(':id', record.opb_id);

                                    if (params.opb_id !== record.opb_id) {
                                        Location.navigate({
                                            url: `${redirectLink}?opb_id=${record.opb_id}&opb_no=${record.opb_bno}&opno=${record.opb_opno}`,
                                        });

                                        getReports(record.opb_id);
                                    }
                                }}
                            ></VisitInfo>
                        ) : /* Patient Visit Information Ends */

                            null}
                        {/* Guest Card Ends */}

                        <div className="details-section">
                            <div className="left-section">
                                <Card className="card card-shadow">
                                    <div className="card-title" style={{ width: '100%' }}>
                                        <h3>{t('REPORTS')}</h3>
                                    </div>

                                    <div className="left-bottom">
                                        {/**report_present varible tells us if the final report is ready, Using that we control final report  view */}
                                        {/* {finalReport && finalReport.report_present ? */}

                                        <div className="report-tabs-wrapper">
                                            {/* Report Tabs */}
                                            {
                                                <div
                                                    className={`report-tab card card-shadow ${selected.item_ptr === finalReport.item_ptr ? 'active' : null
                                                        }`}
                                                    onClick={() => {
                                                        if (loadingIndex === null) selectFinalReport();
                                                    }}
                                                >
                                                    <div className="report-selected">
                                                        {loadingIndex === 'finalReport' ? (
                                                            <div className="loading-spinner">
                                                                {/* Add your spinner here */}
                                                                <Spin size="small" />
                                                            </div>
                                                        ) : null}
                                                        <span>{t('Final Report')}</span>
                                                    </div>
                                                </div>
                                            }

                                            {/* Report Tabs */}

                                            {patient.scrReportmas.map((result, index) => {
                                                return (
                                                    <div
                                                        key={index}
                                                        className={`report-tab test-name card card-shadow ${result.report_available
                                                                ? selected &&
                                                                    selected.opbilld &&
                                                                    selected.opbilld[0].opbd_itemptr === result.opbilld[0].opbd_itemptr
                                                                    ? 'active'
                                                                    : ''
                                                                : 'notactive'
                                                            }`}
                                                        onClick={() => {
                                                            // # Note  We have to implement a prop to control how the report needs to be displayed
                                                            // We have to call this function for the meta viewer
                                                            // reportPreview(result);

                                                            if (loadingIndex === null) {
                                                                selectReportWithLoading(result, index); // Call the updated function
                                                            }

                                                            // For Mobile view we have to open the modal
                                                            if (isMobile) {
                                                                setReportVisible(true);
                                                            }
                                                        }}
                                                    >
                                                        <div className="report-selected">
                                                            {loadingIndex === index ? (
                                                                <div className="loading-spinner">
                                                                    {/* Add your spinner here */}
                                                                    <Spin size="small" />
                                                                </div>
                                                            ) : null}
                                                            <span>
                                                                {index + 1}. {result.scrReportMas.srepmd_desc}
                                                            </span>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </Card>
                            </div>

                            {/* Right Section */}
                            {enableGeneticConsultation ? (
                                <div className="card right-section">
                                    <div className="tab-section">
                                        <Tabs destroyInactiveTabPane={true}>
                                            {selected && selected.report_links ? (
                                                selected.report_links
                                                .slice() // create a shallow copy to avoid mutating the original array
                                                .sort((a, b) => a.sflink_id - b.sflink_id) // sort by sflink_id in ascending order
                                                .map((report, index) => {
                                                    // * Determines the tab name based on the type of the report.
                                                    let tabName;

                                                    // Map RAW to VCF before looking up tabNames
                                                    const normalizedType = report.sflink_type === 'RAW' ? 'VCF' : report.sflink_type;

                                                    const tabNames = {
                                                        RPT: 'Report',
                                                        VCF: 'Raw Data',
                                                        JSON: 'Json Data',
                                                    };

                                                    tabName = tabNames[normalizedType];

                                                    // Create a shallow clone and update the sflink_type
                                                    const updatedReport = {
                                                        ...report,
                                                        sflink_type: normalizedType,
                                                    };
                                                    return report.sflink_filename ? (
                                                        <TabPane tab={`${tabName}`} key={report.sflink_id}>
                                                            <div>{reportPreview(updatedReport,reportConfig)}</div>
                                                        </TabPane>
                                                    ) : null;
                                                })
                                            ) : (
                                                <>
                                                    <div className="">
                                                        <Empty />
                                                    </div>
                                                </>
                                            )}
                                        </Tabs>
                                    </div>
                                </div>
                            ) : (
                                isMobile ? null : (
                                    <div className="card card-shadow right-section">
                                        <div className="tab-section">
                                            {selected ? <ReportLinkPdfViewer selected={selected} reportConfig={reportConfig} /> : null}
                                        </div>
                                    </div>
                                )
                            )}
                            {/* Right Section Ends */}
                        </div>

                        {/* In case of Mobile */}
                        <Modal
                            onOk={null}
                            onCancel={() => {
                                setReportVisible(false);
                            }}
                            footer={null}
                            width="100vw"
                            className="fullscreen-modal"
                            visible={reportVisible}
                            style={{ top: 0 }}
                            destroyOnClose={true}
                        // bodyStyle={{ height: '100vh' }}
                        >
                            <ReportLinkPdfViewer selected={selected} reportConfig={reportConfig} />
                        </Modal>
                        {/* In case of Mobile Ends */}

                        <Modal
                            destroyOnClose={true}
                            footer={null}
                            title={t('Upload')}
                            visible={uploadVisible}
                            okText="Okay"
                            onOk={() => {
                                setUploadVisible(false);
                            }}
                            onCancel={() => {
                                setUploadVisible(false);
                            }}
                        >
                            <UploadFile
                                // bill_id={params.opb_id}
                                setVisible={setUploadVisible}
                                accession_no={params.accessionno}
                                getReports={() => {
                                    getReports(params.opb_id);
                                }}
                                // publishReport={reportPublish}
                                fileName={fileName}
                                {...props}
                                urlParams={params}
                                details={patient}
                                callBack={(element) => {
                                    // if (element.success) {
                                    //   setUploadVisible(false);
                                    getReports(params.opb_id);
                                    getfileLinks();
                                    // }
                                }}
                            />
                        </Modal>
                    </Card>
                </>
            )}
        </>
    );
}

/**
 * A temporary component to avoid the backend logic .
 *
 * Inside im always a front end dev
 * This implementation should have been in the backend to avoid all the
 * data transfer
 *
 * @param {*} param0
 * @returns
 */
function ReportLinkPdfViewer({ selected = { report_links: [] }, reportConfig = {} }) {
    let report = null;

    // In case of final report , we have to define the name
    if (selected.final_report) {
        report = {
            sflink_filename: selected.sflink_filename,
        };
    } else {
        let reportLink = [];

        // We need to remove all the blank and only keep RPT records'

        if (selected.report_links) {
            //
            reportLink = selected.report_links
                .filter((record) => record.sflink_type === 'RPT' && record.sflink_filename !== '')

                .filter((fileLink) => {
                    return fileLink.sflink_type === 'RPT';
                });
        }

        //
        if (reportLink.length) {
            report = reportLink[reportLink.length - 1];
        }
    }

    return report ? (
        <ReportPreviewFileLoader
            config={reportConfig}
            selected={{
                report_type: 'RPT',
                report_path: report.sflink_filename,
            }}
        />
    ) : (
        <Empty />
    );
}

// }

/**
 * Component for uploading files.
 *
 * @param {Object} props - Component props.
 * @param {function} setVisible - Function to control visibility of the component.
 * @param {string} accession_no - Accession number.
 * @param {function} getReports - Function to fetch reports.
 * @param {string} fileName - Name of the file.
 * @param {function} callBack - Callback function.
 * @param {Object} details - Bill Details object.
 */

function UploadFile({ setVisible, accession_no, getReports, fileName, callBack, details, urlParams, ...props }) {
    const { Title } = Typography;
    const [loading, setLoading] = useState(false);


    // Combined state for all file inputs
    const [files, setFiles] = useState({
        reportPath: null,
        rawReportData: null,
        jsonData: null,
    });
    /**
     * Function to submit the files.
     */
    async function submit() {
        setLoading(true);

        // Api params for two api calls for upload
        let apiParams = [];

        // Api params for the pdf file
        apiParams.push({
            file_type: 'File',
            accession_no: accession_no,
            opb_bno: '',
            type: 'RPT',
            // file: reportPath,
            // file: { reportPath, rawReportData },/
            file: files,
        });

        // await this.uploadSelectedFiles();
        for (const payload of apiParams) {
            // console.log("PAyload",payload)
            // apiParams.map(async(ele)=>{
            await uploadFile(payload, fileName, callBack, details, urlParams, props);

            // })
        }

        setLoading(false);

        // getReports();
    }

    /**
     * Uploads a file to the server and calls the necessary APIs.
     * nura api to create records in scr file links
     * @param {Object} payload - Payload object containing file details.
     */
    async function uploadFile(payload, fileName, callBack, details, urlParams, props) {
        let filePath;
        // Prepare file names and form data.
        // Filter the bill details to include only those with package mode 'PCK' and item pointer
        let billDetails = details.opReg.opbilld.filter((val) => val.opbd_packagemode === 'PCK' && val.opbd_itemptr === urlParams.item_ptr);

        // Generate a formatted filename using properties
        let fileNameFormat =
            'GReport_' + details.scrReportmas[0].scrReportMas.srepmd_repcode + '_' + details.opReg.opb_opno + '_' + billDetails[0].opbd_id;

        // Check if the props object  requireLinuxPath that evaluates to true
        if (props.requireLinuxPath) {
            // If true, replace all backslashes with forward slashes in the file path to match Linux/Unix format
            filePath = String.raw`${fileName.filepath}`.replace(/\\/g, '/');
        } else {
            // If false, use the file path as it is, typically for Windows paths
            filePath = fileName.filepath;
        }

        let formData = new FormData();

        let { reportPath, rawReportData, jsonData } = payload.file;

        // Handle raw report data.
        // if (rawReportData) {
        // rawName = payload.file.rawReportData;
        rawReportData['file_type'] = 'RAW'; // Assign file_type for raw report data
        // }
        // Append form data.
        formData.append('file_type', payload.file_type); // Append file_type from payload
        formData.append('accession_no', payload.accession_no); // Append accession_no from payload
        formData.append('type', payload.type); // Append type from payload
        formData.append('file_name', fileNameFormat); // Append formatted file_name
        // pdfName = payload.file.reportPath;
        reportPath['file_type'] = 'REP'; // Assign file_type for PDF report path
        // jsonData['file_type'] = 'REP'
        formData.append('filepathPdf', `${filePath}${reportPath.file_type}`); // Append PDF file path
        formData.append('filepathRaw', `${filePath}${rawReportData.file_type}`);
        formData.append('filepathJson', `${filePath}${rawReportData.file_type}`); // Append raw file path if exists
        formData.append('reportPathPdf', reportPath); // Append PDF report path
        formData.append('reportPathRaw', rawReportData); // Append Raw path
        formData.append('reportPathJson', jsonData);
        /**Upload file and update UI.*/
        const result = await SCRFilesLink.uploadReport(formData, props.uploadUrl,props); // Upload the prepared form data

        getReports(); // Refresh UI to reflect changes
        let uploadFile;

        if (result) {
            setVisible(false); // Hide component upon successful upload
            // Prepare body for second upload request
            let body = {
                file: result.result, // Uploaded file result
                // accession_no: payload.accession_no, // Accession number
                type: payload.type, // Type of file
                bill_id: billDetails[0].opbd_hdrid,
                item_ptr: urlParams.item_ptr,
            };
            // Check if the payload contains an accession number
            if (payload.accession_no) {
                // Add the accession number from the payload to the body objec
                body = {
                    ...body,
                    accession_no: payload.accession_no,
                };
            }

            uploadFile = await SCRFilesLink.uploadFile(body);

            message.success(uploadFile.message); // Display success message

            callBack(uploadFile); // Execute callback function with uploadFile details
        } else {
            message.error('Please check the files');
        }
    }

    /**
     * Generalized event handler for selecting files.
     *
     * @param {Object} e - Event object.
     * @param {string} field - The field name to update in the state.
     */
    function handleFileChange(e, field) {
        setFiles((prevFiles) => ({
            ...prevFiles,
            [field]: e.target.files[0],
        }));
    }
    return (
        <div className="card card-shadow">
            <Form onFinish={submit} {...formItemLayout}>
                <>
                    <div>
                        {/* <form id="myform"> */}
                        {/* <br /> */}
                        <Title level={5}>Report Path</Title>
                        {/* <label>Select File</label> */}
                        {/* <br /> */}
                        <Form.Item name="report_path" label="Select File" rules={[{ required: true, message: 'Please Select Report Path' }]}>
                            <input type="file" name="reportPath" accept={props.report} onChange={(e) => handleFileChange(e, 'reportPath')} />
                        </Form.Item>
                        <>
                            <Title level={5}>Raw Report Data</Title>
                            <Form.Item name="raw_path" label="Select File" rules={[{ required: true, message: 'Please Select Raw Path' }]}>
                                <input type="file" name="rawReportData" accept={props.raw} onChange={(e) => handleFileChange(e, 'rawReportData')} />
                            </Form.Item>

                            <Title level={5}>JSON Report Data</Title>
                            <Form.Item name="json_path" label="Select File" rules={[{ required: true, message: 'Please Select Raw Path' }]}>
                                <input type="file" name="jsonReportData" accept={props.json} onChange={(e) => handleFileChange(e, 'jsonData')} />
                            </Form.Item>

                            <Button loading={loading} htmlType="submit">
                                Submit
                            </Button>
                        </>
                    </div>
                </>
            </Form>
        </div>
    );
}

/**
 *
 * @returns
 *
 * Loading Cinical Info
 */
// import  {useEffect, useState} from 'react';

// import {useTranslation} from 'soxo-bootstrap-core'

// import {Modal, Button, Typography} from 'antd';
// import ClinicalInformation from '../../../emr/components/clinical-information/clinical-information';

// const {Title} = Typography;

export function LabResultsButton({ referenceId, mode, ...props }) {
    const { t, i18n } = useTranslation(); // To Translate to another language

    let [visible, setVisible] = useState(false);

    /**
     * Get call
     */

    useEffect(() => { }, []);

    return (
        <div className="lab-results">
            <div className="paga-actions">
                <Button
                    type="secondary"
                    size={'small'}
                    onClick={() => {
                        setVisible(true);
                    }}
                >
                    {t('View Lab Results')}
                </Button>
            </div>

            <Modal
                destroyOnClose={true}
                visible={visible}
                footer={null}
                onCancel={() => {
                    setVisible(false);
                }}
                width={'80%'}
                maskClosable={false}
            >
                <div>
                    <DoctorNotesLabResult {...props} mode={mode} bill_id={referenceId}></DoctorNotesLabResult>
                </div>
            </Modal>
        </div>
    );
}
